import hash from "object-hash";

const queue = {};

export default {
  install(Vue) {
    Vue.prototype.$redirectTo = async function(name, options = {}) {
      if (!this.$router) {
        throw new Error("vue-router not installed");
      }

      options = options || {};
      const location = { name };
      if (options.query) {
        location.query = options.query;
      }

      if (options.params) {
        location.params = options.params;
      }

      const id = hash(location);
      if (queue[id]) {
        return;
      }

      queue[id] = location;

      try {
        return await this.$router.push(location);
      } catch (e) {
        console.error(e);
      } finally {
        delete queue[id];
      }
    };
  },
};
